export const ProgressRing = ({ value, target, size = 150, stroke = 14, testId }) => {
  const pct = Math.min(value / Math.max(target, 1), 1);
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const hit = pct >= 1;
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }} data-testid={testId}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#F0EAE1" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2} cy={size / 2} r={r} fill="none"
          stroke={hit ? '#81B29A' : '#E07A5F'} strokeWidth={stroke} strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={c * (1 - pct)}
          style={{ transition: 'stroke-dashoffset 800ms cubic-bezier(.2,.8,.2,1)' }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-xl wf-float" aria-hidden>{hit ? '🏆' : '🔥'}</span>
        <span className="text-3xl font-extrabold text-[#2D2623] leading-none mt-1" data-testid={testId && `${testId}-value`}>
          {value}<span className="text-base font-semibold text-[#9A8E85]">/{target}</span>
        </span>
      </div>
    </div>
  );
};
